import { useQuery } from '@tanstack/react-query'
import { api } from '@/utils/api'
import { createRouteForAPI } from '@/utils/helpers/urlHelper'
import { apiService } from '@/utils/api/url'

import { QuerySearchService, Service } from '@/types/service'

export const QUERY_KEY_GET_SERVICES = 'QUERY_KEY_GET_SERVICES'
export const useGetServices = ({
  params,
  branch,
  enabled = true,
}: {
  branch: string
  params: QuerySearchService
  enabled?: boolean
}) => {
  const res = useQuery({
    enabled: !!branch && enabled,
    queryKey: [QUERY_KEY_GET_SERVICES, branch, JSON.stringify(params)],
    staleTime: 60 * (60 * 1000), // 60mins
    queryFn: () =>
      api
        .get(createRouteForAPI(apiService, { branch }), {
          params,
        })
        .then(({ data }) => {
          const res = data.data as Service[]
          return res
        }),
  })
  return res
}
